import axios from 'axios'

const apiUrl = import.meta.env.VITE_API_URL
const ApiClientOpen = axios.create({
	baseURL: apiUrl,
})

ApiClientOpen.interceptors.request.use(
	async config => {
		config.headers['Content-Type'] = `Application/json`
		return config
	},
	async error => {
		return await Promise.reject(error)
	}
)

ApiClientOpen.interceptors.response.use(
	response => {
		return response
	},
	async error => {
		return await Promise.reject(error)
	}
)
// End of Response interceptor

export default ApiClientOpen
